/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/require-default-props */

import React, { useState, useEffect } from 'react';
import StepLabel from '@material-ui/core/StepLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { ArrowBack } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { COLOR } from 'assets/styles/colors';
import LoitLogo from 'assets/icons/loit-logo-dash.svg';
import {
  Container, BoxStepper, ContainerHeader, StyledStepper, StyledStep,
} from './styles';

export const CustomizedSteppers = () => {
  const [activeStep, setActiveStep] = useState(0);
  const steps = ['Upload/Cálculo', 'Dados', 'Pagamento', 'Documentos/Atermação', 'Download'];
  const pathName = window.location.pathname;

  const history = useHistory();

  useEffect(() => {
    if (pathName === '/calculo') setActiveStep(0);
    if (pathName.search('/resultado/') === 0) setActiveStep(0);
    if (pathName === '/dados') setActiveStep(1);
    if (pathName === '/pagamento') setActiveStep(2);
    if (pathName === '/documentos' || pathName === '/atermacao') setActiveStep(3);
    if (pathName === '/download') setActiveStep(4);
  }, [pathName]);

  return (
    <Container>
      <BoxStepper>
        <ContainerHeader activeStep={activeStep}>
          <Tooltip title="Voltar" arrow>
            <a
              onClick={history.goBack}
              style={{
                left: '18px',
                cursor: 'pointer',
              }}
            >
              <ArrowBack aria-label="Voltar" style={{ color: COLOR.WHITE_1 }} />
            </a>
          </Tooltip>
          <img
            src={LoitLogo}
            alt="logo loit fgts"
          />
        </ContainerHeader>
        <StyledStepper alternativeLabel activeStep={activeStep}>
          {steps.filter((item, i) => i !== 4).map((label) => (
            <StyledStep key={label}>
              <Tooltip title={label} arrow>
                <StepLabel>{label}</StepLabel>
              </Tooltip>
            </StyledStep>
          ))}
        </StyledStepper>
      </BoxStepper>
    </Container>
  );
};
